import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-bg" }
const _hoisted_2 = { class: "modal modal--feedback" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "modal-title" }
const _hoisted_5 = { class: "modal-text text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "modal-icon",
        src: $setup.iconSrc,
        alt: ""
      }, null, 8, _hoisted_3),
      _createElementVNode("p", _hoisted_4, _toDisplayString($props.mainTitle), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString($props.subTitle), 1),
      _createVNode($setup["ButtonComponent"], {
        md: "",
        primary: "",
        onClick: $setup.onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.okTitle), 1)
        ]),
        _: 1
      })
    ])
  ]))
}